/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import produce from "immer";
import { call, put, takeLatest } from "redux-saga/effects";
import { getSearchResult, App, SearchReq } from "../../../api/apiCalls";
import {
  LoadingStatus,
  usePortalStateSelector,
} from "../../../rootReducer/actions";
import { MainPageEvent } from "../../MainUi";

export enum AppsByCategoryPageEvent {
  RESET = "RESET",
  GET_APPS_BY_CATEGORY_PAGE_DATA = "GET_APPS_BY_CATEGORY_PAGE_DATA",
  GET_APPS_BY_CATEGORY_PAGE_DATA_RESULT = "GET_APPS_BY_CATEGORY_PAGE_DATA_RESULT",
  GET_APPS_BY_CATEGORY_PAGE_DATA_FAIL = "GET_APPS_BY_CATEGORY_PAGE_DATA_FAIL",
}

export interface GetAppsByCategoryAction {
  type: AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA;
  payload: SearchReq;
}

export interface ResetAppsByCategory {
  type: AppsByCategoryPageEvent.RESET;
}

export interface GetAppsByCategorySuccessAction {
  type: AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA_RESULT;
  results: {
    payload: App[];
    totalPages: number;
    pageNumber: number;
    totalElements: number;
  };
}

export interface GetAppsByCategoryActionFail {
  type: AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA_FAIL;
}

export type AppsByCategoryPageAction =
  | ResetAppsByCategory
  | GetAppsByCategoryAction
  | GetAppsByCategorySuccessAction
  | GetAppsByCategoryActionFail;

export interface AppsByCategoryPageData {
  loadingStatus: LoadingStatus;
  apps: App[];
  pageNo: number;
  totalPages: number;
  totalElements: number;
}

const initialState = {
  loadingStatus: LoadingStatus.LOADING_STARTED,
  apps: [],
  pageNo: 0,
  totalPages: 0,
  totalElements: 0,
  error: false,
  notification: {
    show: false,
  },
};

export function AppsByCategoryPageReducer(
  state: AppsByCategoryPageData = initialState,
  action: AppsByCategoryPageAction
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA: {
        break;
      }

      case AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA_RESULT: {
        draft.loadingStatus = LoadingStatus.LOADING_SUCCESS;
        draft.apps = draft.apps.concat(action.results.payload);
        draft.pageNo = action.results.pageNumber;
        draft.totalPages = action.results.totalPages;
        draft.totalElements = action.results.totalElements;
        //TODO set any other value to the state here
        break;
      }

      case AppsByCategoryPageEvent.RESET: {
        draft.apps = [];
        draft.loadingStatus = LoadingStatus.LOADING_STARTED;
        break;
      }

      case AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA_FAIL: {
        draft.loadingStatus = LoadingStatus.LOADING_ERROR;
        break;
      }
    }
  });
}

export function useAppsByCategoryPageDataSelector(): AppsByCategoryPageData {
  return usePortalStateSelector<AppsByCategoryPageData>(
    (ev) => ev.appsByCategoryPageData
  );
}

export const appsByCategoryPageSagas = [getAppsByCategoryPageDataSaga];

function* getAppsByCategoryPageDataSaga() {
  yield takeLatest(
    AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA,
    callAppsByCategoryPageData
  );
}

const arr = ["E1008", "E1009", "E1010", "E1011", "E1012", "E1013"];

function* callAppsByCategoryPageData(action: GetAppsByCategoryAction) {
  try {
    const { payload, statusCode, totalPages, pageNumber, totalElements } =
      yield call(getSearchResult, action.payload);

    if (arr.includes(statusCode)) {
      yield put({
        type: MainPageEvent.SIGN_OUT_SUCCESS,
      });
      yield put({
        type: MainPageEvent.SHOW_NOTIFICATION,
        payload: "JWT expired",
      });
      window.location.reload();
    } else {
      yield put({
        type: AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA_RESULT,
        results: { payload, totalPages, pageNumber, totalElements },
      });
    }
  } catch (e) {
    console.error(e);
    yield put({
      type: AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA_FAIL,
    });
  }
}
